export default __webpack_public_path__ + "static/media/scw-grid-3.d7ace6eb.svg";